import { useMemo, useState } from "react";
import {
  Badge,
  Box,
  Button,
  Card,
  CardContent,
  Grid,
  Typography,
} from "../../../components";
import { SessionService } from "../../../services";
import { buildFiltrosBody, filtrosIniciais } from "./monitor-faturamento";
import {
  MonitorFatFiltros,
  MonitorFatKpis,
  MonitorFatProdutosServicos,
  MonitorFatMeioPagamento,
  MonitorFatRankingClientes,
  MonitorFatMensalComparativo,
  MonitorFatGrupoProduto,
  MonitorFatGrupoServico,
  MonitorFatRankingVendedoresProdutos,
  MonitorFatRankingVendedoresServicos,
  MonitorFatRankingServicos,
  MonitorFatEstoque,
  MonitorFatItensSemGiro,
} from "./components";

const sessionService = new SessionService();

const MonitorFaturamento = () => {
  const usuario = sessionService.getUsuario();
  const empresa = sessionService.getEmpresa();
  const acessosEmpresas = usuario?.acessosEmpresas || [];

  const filtrosPadrao = {
    ...filtrosIniciais,
    empresas: empresa ? [empresa] : [],
  };

  const [open, setOpen] = useState(false);
  const [draft, setDraft] = useState(filtrosPadrao);
  const [filtros, setFiltros] = useState(filtrosPadrao);
  const filtrosBody = useMemo(() => buildFiltrosBody(filtros), [filtros]);

  const activeCount =
    (acessosEmpresas.length > 0 ? filtros.empresas?.length || 0 : 0) +
    (filtros.contas?.length || 0) +
    (filtros.centroCusto ? 1 : 0);

  const abrirFiltros = () => {
    setDraft(filtros);
    setOpen(true);
  };

  return (
    <Card className="minimal-layout-card">
      <CardContent className="minimal-layout-card-content rolagem">
        <Box sx={{ display: "flex", flexDirection: "column", pb: "24px" }}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "flex-start",
              pb: 3,
            }}
          >
            <Box>
              <Typography variant="h3" sx={{ fontWeight: 700 }}>
                Monitor Faturamento
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Acompanhe recebimentos, pagamentos, inadimplência e fluxo de
                caixa
              </Typography>
            </Box>
            <Badge
              badgeContent={activeCount}
              color="primary"
              overlap="rectangular"
            >
              <Button
                variant="outlined"
                color="primary"
                onClick={abrirFiltros}
                startIcon={<i className="ph-fill ph-sliders-horizontal" />}
                sx={{ whiteSpace: "nowrap" }}
              >
                Filtros
              </Button>
            </Badge>
          </Box>
          <MonitorFatFiltros
            filtros={filtros}
            filtrosPadrao={filtrosPadrao}
            onAplicar={setFiltros}
            acessosEmpresas={acessosEmpresas}
            draft={draft}
            setDraft={setDraft}
            open={open}
            setOpen={setOpen}
          />
        </Box>

        <MonitorFatKpis filtrosBody={filtrosBody} />

        <Grid container spacing={2} alignItems="stretch" sx={{ mt: 0.5 }}>
          <Grid item xs={12} md={6}>
            <MonitorFatProdutosServicos filtrosBody={filtrosBody} />
          </Grid>
          <Grid item xs={12} md={6}>
            <MonitorFatMeioPagamento filtrosBody={filtrosBody} />
          </Grid>

          <Grid item xs={12} md={6}>
            <MonitorFatRankingClientes filtrosBody={filtrosBody} />
          </Grid>
          <Grid item xs={12} md={6}>
            <MonitorFatMensalComparativo filtrosBody={filtrosBody} />
          </Grid>

          <Grid item xs={12} md={6}>
            <MonitorFatGrupoProduto filtrosBody={filtrosBody} />
          </Grid>
          <Grid item xs={12} md={6}>
            <MonitorFatGrupoServico filtrosBody={filtrosBody} />
          </Grid>

          <Grid item xs={12} md={4}>
            <MonitorFatRankingVendedoresProdutos filtrosBody={filtrosBody} />
          </Grid>
          <Grid item xs={12} md={4}>
            <MonitorFatRankingVendedoresServicos filtrosBody={filtrosBody} />
          </Grid>
          <Grid item xs={12} md={4}>
            <MonitorFatRankingServicos filtrosBody={filtrosBody} />
          </Grid>

          <Grid item xs={12}>
            <MonitorFatEstoque filtrosBody={filtrosBody} />
          </Grid>

          <Grid item xs={12}>
            <MonitorFatItensSemGiro filtrosBody={filtrosBody} />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default MonitorFaturamento;
